class CurdCorner {
  constructor() {
    this.modals = document.querySelectorAll('.curd-corner__modal');
    this.buttons = document.querySelectorAll('[data-cheese-modal]');
    this.body = document.body;

    this.init();
  }

  init() {
    // Add click listeners to all cheese buttons
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = button.getAttribute('data-cheese-modal');
        this.openModal(modalId);
      });
    });

    // Add click listeners to close buttons and overlays
    this.modals.forEach(modal => {
      const closeElements = modal.querySelectorAll('[data-close-modal]');
      closeElements.forEach(element => {
        element.addEventListener('click', () => {
          this.closeModal(modal);
        });
      });
    });

    // Close modal on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const activeModal = document.querySelector('.curd-corner__modal.active');
        if (activeModal) {
          this.closeModal(activeModal);
        }
      }
    });
  }

  openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add('active');
      this.body.classList.add('modal-open');

      // Focus trap
      const focusableElements = modal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }
  }

  closeModal(modal) {
    modal.classList.remove('active');
    this.body.classList.remove('modal-open');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CurdCorner();
  });
} else {
  new CurdCorner();
}
